import { render, staticRenderFns } from "./BullentinContent.vue?vue&type=template&id=be798f42"
import script from "./BullentinContent.vue?vue&type=script&lang=js"
export * from "./BullentinContent.vue?vue&type=script&lang=js"
import style0 from "./BullentinContent.vue?vue&type=style&index=0&id=be798f42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports